import { render, staticRenderFns } from "./Workprojectbudgetstatistical.vue?vue&type=template&id=1948d3aa&scoped=true&"
import script from "./Workprojectbudgetstatistical.vue?vue&type=script&lang=js&"
export * from "./Workprojectbudgetstatistical.vue?vue&type=script&lang=js&"
import style0 from "./Workprojectbudgetstatistical.vue?vue&type=style&index=0&id=1948d3aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1948d3aa",
  null
  
)

export default component.exports